export default __webpack_public_path__ + "static/media/login-bg-41.2e801cab.jpg";